import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Media } from '@digilize/shared/definitions/src';

@Component({
  selector: 'lib-profile-circle-img',
  templateUrl: './profile-circle-img.component.html',
  styleUrls: ['./profile-circle-img.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ProfileCircleImgComponent implements OnInit {
  @Input() image: Media;
  constructor() {}

  ngOnInit() {}
}
